import type { BuildInPlacements } from 'rc-trigger/lib/interface'

const autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1,
}

const targetOffset: [number, number] = [0, 0]

/** Matches event-card.tsx top tooltip align offset magnitude. */
export const RC_TOOLTIP_GAP_PX = 20

export function createRcTooltipPlacements(gapPx: number): BuildInPlacements {
  return {
    left: {
      points: ['cr', 'cl'],
      overflow: autoAdjustOverflow,
      offset: [-gapPx, 0],
      targetOffset,
    },
    right: {
      points: ['cl', 'cr'],
      overflow: autoAdjustOverflow,
      offset: [gapPx, 0],
      targetOffset,
    },
    top: {
      points: ['bc', 'tc'],
      overflow: autoAdjustOverflow,
      offset: [0, -gapPx],
      targetOffset,
    },
    bottom: {
      points: ['tc', 'bc'],
      overflow: autoAdjustOverflow,
      offset: [0, gapPx],
      targetOffset,
    },
    topLeft: {
      points: ['bl', 'tl'],
      overflow: autoAdjustOverflow,
      offset: [0, -gapPx],
      targetOffset,
    },
    leftTop: {
      points: ['tr', 'tl'],
      overflow: autoAdjustOverflow,
      offset: [-gapPx, 0],
      targetOffset,
    },
    topRight: {
      points: ['br', 'tr'],
      overflow: autoAdjustOverflow,
      offset: [0, -gapPx],
      targetOffset,
    },
    rightTop: {
      points: ['tl', 'tr'],
      overflow: autoAdjustOverflow,
      offset: [gapPx, 0],
      targetOffset,
    },
    bottomRight: {
      points: ['tr', 'br'],
      overflow: autoAdjustOverflow,
      offset: [0, gapPx],
      targetOffset,
    },
    rightBottom: {
      points: ['bl', 'br'],
      overflow: autoAdjustOverflow,
      offset: [gapPx, 0],
      targetOffset,
    },
    bottomLeft: {
      points: ['tl', 'bl'],
      overflow: autoAdjustOverflow,
      offset: [0, gapPx],
      targetOffset,
    },
    leftBottom: {
      points: ['br', 'bl'],
      overflow: autoAdjustOverflow,
      offset: [-gapPx, 0],
      targetOffset,
    },
  }
}
